import React from 'react'
import {connect} from 'react-redux'
import styles from './RoutesPage.scss'
import layout from '../layout.scss'
import cx from 'classnames'
import {Routes} from './Routes'
import {getExperienceId} from '../ExperiencesApp/ExperiencesApp'
import {experienceActions, experienceSelectors} from 'data/resources/experiences'
import Helmet from 'react-helmet'

export class _RoutesPage extends React.PureComponent {
  componentDidMount () {
    const {loadExperience} = this.props
    loadExperience()
  }

  componentDidUpdate (prevProps) {
    const {loadExperience} = this.props
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      loadExperience()
    }
  }

  render () {
    const {experience} = this.props

    return (
      <div className={cx(layout.container, styles.RoutesPage)}>
        {experience && <Helmet title={experience.name} />}
        <div className={layout.mainColumn}>
          {experience && <Routes experience={experience} editable showSwitch />}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => {
      dispatch(experienceActions.read(experienceId))
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    experience: experienceSelectors.find(state, experienceId)
  }
}

export const RoutesPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(_RoutesPage)
